import { Helmet } from "react-helmet";
import SecondHeader from "../Header/SecondHeader";
import ReportTypes from "./ReportsTypes/ReportTypes";
import { Outlet, useLocation } from "react-router-dom";
import trans from "../../utils";

export default function Reports() {
  const { pathname } = useLocation();
  return (
    <>
      <Helmet>
        <title>Reports</title>
        <meta name="description" content="Reports" />
      </Helmet>
      <SecondHeader title={trans("reports")} type="reports" />

      {pathname === "/reports" ? <ReportTypes /> : <Outlet />}
    </>
  );
}
